import { useState, useCallback } from "react";
import CTAs from "./CTAs";
import { Trash } from "iconsax-reactjs";

const DebtorDeletion = ({ onClose }) => {
  return (
    <div className="relative shadow-[0px_10px_60px_rgba(0,_0,_0,_0.1)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-col items-start justify-start p-6 gap-[40px] max-w-full max-h-full overflow-auto text-left text-lg text-neutrals-neutral-900 font-open-sans-ff-heading-1 border-[1px] border-solid border-neutrals-neutral-100">
      <div className="w-[386px] flex flex-row items-start justify-between">
        <div className="flex-1 flex flex-col items-start justify-start gap-[10px]">
          <div className="rounded-3xs bg-semantics-high-high-50 flex flex-row items-start justify-start p-2.5">
            {/* <img className="w-5 relative h-5" alt="" src="assets/delete.svg" /> */}
            <Trash size={20} color="#d93c3d" />
          </div>
          <div className="self-stretch flex flex-col items-start justify-start gap-[6px]">
            <div className="self-stretch relative font-semibold">
              Delete debtor details
            </div>
            <div className="self-stretch relative text-sm leading-[20px] font-inter text-neutrals-neutral-300">
              Are you sure you want to delete this detail? This action cannot be
              undone.
            </div>
          </div>
        </div>
        <img
          className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer"
          alt=""
          src="assets/cancel.svg"
          onClick={onClose}
        />
      </div>
      <div className="flex flex-row items-start justify-start gap-[10px] text-sm">
        <CTAs
          type="Secondarybtn"
          text="Cancel"
          borderColor="border-neutrals-neutral-100"
          width="w-[188px]"
          position="relative"
          onClick={onClose}
        />

        <CTAs
          type="Deletebtn"
          text="Delete"
          width="w-[188px]"
          position="relative"
        />
      </div>
    </div>
  );
};

export default DebtorDeletion;
